import { Component, Input } from '@angular/core';
import { UserResponse } from '../../../models/responses/user-response';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormModuleTemplate } from '../../../module-templates/form-module-template';
import { NgIf } from '@angular/common';
import { UserService } from '../../../services/user.service';
import { UpdateUserInfoRequest } from '../../../models/requests/update-user-info-request';
import { MatSnackBar } from '@angular/material/snack-bar';
import { localStoragevarNames } from '../../../utilities/local-storage-utils';
import { resetUserInLocalStorage } from '../../../utilities/user-utils';

@Component({
  selector: 'app-update-user-info',
  standalone: true,
  imports: [
    FormModuleTemplate,
    NgIf
  ],
  templateUrl: './update-user-info.component.html',
  styleUrl: './update-user-info.component.scss'
})
export class UpdateUserInfoComponent {
  @Input() connectedUser!: UserResponse;
  editUserForm!: FormGroup;
  isEditing: boolean = false;
  isLoading: boolean = false;
  passwordStandardString: string = 'impossibletobechosenbyuser4578$2^5';

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.initUserForm();
  }

  initUserForm() {
    this.editUserForm = this.formBuilder.group({
      firstName: [this.connectedUser.firstName, Validators.required],
      lastName: [this.connectedUser.lastName, Validators.required],
      email: [this.connectedUser.email, [Validators.required, Validators.email]],
      password: [this.passwordStandardString, [Validators.required, Validators.minLength(5), Validators.maxLength(60)]]
    });
  }

  onCancelClicked(){
    this.isEditing = false;
    this.editUserForm.controls['password'].setValue(this.passwordStandardString);
  }

  onSubmitForm() {
    if (this.editUserForm.valid) {
      this.isLoading = true;
      this.isEditing = true;

      const formValues = this.editUserForm.value;
      const request: UpdateUserInfoRequest = {
        email: formValues['email'],
        firstName: formValues['firstName'],
        lastName: formValues['lastName'],
        password: formValues['password'] == this.passwordStandardString ? '' : formValues['password']
      }

      this.userService.updateUserInfo(request).subscribe({
        next: (user) => {
          this.isLoading = false;
          this.snackBar.open('Settings updated successfully', 'Close', { duration: 5000 });
          this.connectedUser = user;
          resetUserInLocalStorage(user);
          this.isEditing = false;
          this.initUserForm();
        },
        error: () => {
          this.isLoading = false;
          alert('Server error contact support');
        }
      });
    }
  }
}
